import { render } from "./Footer.vue?vue&type=template&id=52689b12&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=52689b12&scoped=true&lang=scss"

import exportComponent from "/Users/leonardomarsigli/code/LeoMarseo/personal-projects/dirtysocks-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52689b12"]])

export default __exports__